"use client";
import Link from "next/link";
import { FacebookIcon, InstagramIcon, TikTokIcon } from "~/_components/icons";
import { useContext } from "react";
import { StoreContext } from "~/app/store-provider";

export default function Footer() {
  const [store, setStore] = useContext(StoreContext);
  const footerLinks = [
    { id: 1, href: "/about", text: "About" },
    { id: 2, href: "/contact", text: "Contact Us" },
    { id: 3, href: "/privacy", text: "Privacy Policy" },
    { id: 4, href: "/terms", text: "Terms of Service" },
  ];
  const footerSocials = [
    {
      id: 1,
      name: "instagram",
      href:
        store.app?.city?.instagram_url ||
        "https://www.instagram.com/funday.list",
      icon: (
        <InstagramIcon className="fun-svg-shadow-gray fill-current text-white" />
      ),
    },
    {
      id: 2,
      name: "tiktok",
      href: store.app?.city?.tiktok_url || "https://www.tiktok.com/@fundaylist",
      icon: (
        <TikTokIcon className="fun-svg-shadow-gray fill-current text-white" />
      ),
    },
    {
      id: 3,
      name: "facbook",
      href:
        store.app?.city?.facebook_url ||
        "https://www.facebook.com/profile.php?id=61575011402794",
      icon: (
        <FacebookIcon className="fun-svg-shadow-gray fill-current text-white" />
      ),
    },
  ];
  return (
    <footer className="align-center mt-auto flex w-screen flex-col justify-center bg-transparent p-4 text-white">
      <div className="align-center flex justify-center py-2 md:text-center">
        {footerSocials.map((social) => (
          <Link
            key={social.id}
            href={social.href}
            target="_blank"
            aria-label={`Fundaylist ${social.name}`}
            prefetch={true}
            rel="noopener noreferrer"
            className="mx-6 my-3 inline-block h-8 w-8 text-white lg:h-10 lg:w-10"
          >
            {social.icon}
          </Link>
        ))}
      </div>
      <div className="py-2 text-center">
        {footerLinks.map((link) => (
          <a
            key={link.id}
            href={link.href}
            aria-label={link.text}
            className="transition-border mx-3 my-2 inline-block border-b-2 border-transparent pb-1 duration-500 ease-linear hover:border-white"
          >
            {link.text}
          </a>
        ))}
      </div>
      <p className="py-2 text-center">
        &copy; 2025 FundayList All Rights Reserved
      </p>
    </footer>
  );
}
